import { useRef } from "react";
import { getServiciosFincas } from "../services";

const useServicios = () => {
    const isFetchingRef = useRef(false);
    
    const fetchServicios = async () => {
        if (isFetchingRef.current) {
            return;
        }
        
        try {
            isFetchingRef.current = true;
            const response = await getServiciosFincas();
            let misDatos = formData(response);
            return misDatos;
        }
        catch (error) {
            console.error("Error fetching servicios:", error);
        } finally {
            isFetchingRef.current = false;
        }
    }

    const formData = (datos) => {
        return datos.map((item) => ({
            id: item.id,
            nombre: item.nombre,
            group_id: item.group_id
        }));
    }

    return {
        fetchServicios
    };
}

export default useServicios;